// extracted by mini-css-extract-plugin
export default {"list_header":"Teams_list_header__WHCr2","tabContainer":"Teams_tabContainer__5bE1b"};